<template>
  <div id="top" class="dashboard-page home login">
    <main class="main-dashboard">
      <div @click="togglePopupLaw" v-if="isShowPopupLaw" class="popup-law">
        <div class="popup-body" @click="(e) => e.stopPropagation()">
          <div class="popup-title">
            <h1>特定商取引法に基づく表示</h1>
            <img @click="togglePopupLaw" class="close-popup-law" src="../assets/img/close.png"/>
          </div>
          <div class="popup-body-message">
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>販売事業者</p>
              </div>
              <p class="list-point-desc">株式会社アト</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>運営責任者</p>
              </div>
              <p class="list-point-desc">代表取締役社長CEO　奈須田 洋平</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>所在地</p>
              </div>
              <p class="list-point-desc">〒102-0083</p>
              <p class="list-point-desc">東京都千代田区麹町6-6-2 番町麹町ビルディング5F We Work麹町</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>お問合せ先</p>
              </div>
              <p class="list-point-desc">0120-555-001</p>
              <p class="list-point-desc">お問合せ窓口（https://www.ato-co.jp/contact/）</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>電子メールアドレス</p>
              </div>
              <p class="list-point-desc">adx@ato-co.jp</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>商品の販売価格</p>
              </div>
              <p class="list-point-desc">商品毎に記載しております。</p>
              <p class="list-point-desc">印刷からご注文の場合は送料込の金額にて記載しております。</p>
              <p class="list-point-desc">印刷を含まないご注文の場合、広告の印刷、納品にかかる費用はお客様負担にお願いします。</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>ご注文の有効期限</p>
              </div>
              <p class="list-point-desc">ご注文時に定められる各種期限日を過ぎた場合、注文はキャンセルとする</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>支払方法</p>
              </div>
              <p class="list-point-desc">クレジットカード</p>
              <p class="list-point-desc">請求書払い</p>
              <p class="list-point-desc">コンビニ支払い</p>
              <p class="list-point-desc">Pay-easy(ペイジー)決済</p>
              <p class="list-point-desc">ポイント払い</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>支払時期</p>
              </div>
              <p class="list-point-desc">原稿審査完了のお知らせ、入稿データチェック完了のお知らせのメール文面、</p>
              <p class="list-point-desc">または、ADX内の注文リストより、オーダー/詳細画面に表記されている支払期限日までにお支払をお</p>
              <p class="list-point-desc">願い致します。</p>
              <p class="list-point-desc">クレジットカード、ポイント払いにてお支払いの場合は、</p>
              <p class="list-point-desc">原稿審査完了または入稿データチェック完了を持って支払手続きが開始されます。</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>商品の引き渡し時期(役務の提供時期)</p>
              </div>
              <p class="list-point-desc">注文確定のご案内メールの文面、またはADX内の注文リストより、オーダー/詳細画面に表記</p>
            </div> 
            <br />
            <div class="popup-margin">
              <div class="popup-list-point">
                <span>・</span>
                <p>返品、返金とキャンセル</p>
              </div>
              <p class="list-point-desc">役務の履行に欠陥がある場合を除き、返品、返金には応じておりません。</p>
              <p class="list-point-desc">原稿審査・入稿データチェック完了後の返金には応じておりません。</p>
            </div> 
            <br />
          </div>
        </div>
      </div>
      <div class="serviceMenu">
        <div class="secondary">
          <div class="wrap">
            <div class="label">アカウントサービス</div>
            <ul
              class="list"
              :class="{
                'list-staff': !(
                  authStore.state.orgType === 0 ||
                  (authStore.getters.authLevel >= 1 &&
                    authStore.state.orgType !== 0)
                ),
              }"
            >
              <li>
                <a href="/myAccount" class="myacount"
                  >マイアカウント確認・変更</a
                >
              </li>
              <li>
                <a
                  v-if="
                    authStore.state.orgType === 0 ||
                    (authStore.getters.authLevel >= 1 &&
                      authStore.state.orgType !== 0)
                  "
                  href="/accounts/manage"
                  class="add"
                  >アカウント追加・削除</a
                >
              </li>
              <li><a href="#" class="logout">ログアウト</a></li>
            </ul>
            <div class="label">サポート</div>
            <ul class="list">
              <li>
                <a href="/term" class="guide">ご利用ガイド</a>
              </li>
              <li>
                <a href="/faq" class="faq">よくある質問</a>
              </li>
              <li>
                <a
                  href="https://www.ato-co.jp/contact/"
                  target="_blank"
                  class="contact"
                  >お問い合わせ</a
                >
              </li>
            </ul>
            <ul class="banner">
              <li>
                <a href="/landing.html">
                  <img
                    src="../assets/img/bnr01.jpg"
                    alt="ADXトップページ"
                    width="430"
                    height="120"
                  />
                  <div class="text">ADXトップページはこちら<i></i></div>
                </a>
              </li>
              <li>
                <a href="/landing.html#megapos">
                  <img
                    src="../assets/img/bnr02.png"
                    alt="アトの大量投下型ポスティング「メガポス」"
                    width="430"
                    height="120"
                  />
                  <div class="text">
                    アトの大量投下型ポスティング<br
                      class="sp"
                    />「メガポス」はこちら<i></i>
                  </div>
                </a>
              </li>
              <li>
                <a href="https://yoff.life/lp/" target="_blank">
                  <img
                    src="../assets/img/bnr03.png"
                    alt="ポスティングマガジン「yoff」"
                    width="430"
                    height="120"
                  />
                  <div class="text">
                    ポスティングマガジン<br class="sp" />「yoff」はこちら<i></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>

    <footer class="gFooter">
      <div class="contact">
        <div class="wrap-footer">
          <div class="tel">
            <div class="name">お電話でのお問い合わせ</div>
            <a href="tel:0120-555-001"
              ><img
                src="../assets/img/ftr-tel.png"
                alt="TEL. 0120-555-001"
                width="642"
                height="73"
            /></a>
          </div>
          <div class="mail">
            <div class="name">メールでのお問い合わせ</div>
            <a href="https://www.ato-co.jp/contact/" target="_blank"
              ><img
                src="../assets/img/ftr-mail.png"
                alt="ato corporate"
                width="486"
                height="83"
            /></a>
          </div>
        </div>
      </div>
      <div class="corporate">
        <div class="wrap-content">
          <div class="logo watchScroll" data-scroll="ftrLogo">
            <img
              src="../assets/imgs/ftr-logo_a.png"
              alt="ato Inc."
              width="261"
              height="68"
            />
          </div>
          <div class="address">
            〒102-0083 <br class="pc" />東京都千代田区麹町6-6-2番町<br
              class="sp"
            />麹町ビルディング5F We Work麹町
          </div>
          <div class="trademark">
            「ポスティング&reg;」は株式会社アトの商標登録です。<br
              class="sp"
            />（商標登録番号4984197号）
          </div>
          <div class="sns">
            <a href="https://x.com/ato_Inc" target="_blank" class="x"
              ><img
                src="../assets/img/ico-x.svg"
                alt="X"
                width="382"
                height="357"
            /></a>
            <a
              href="https://www.facebook.com/ato.posting/"
              target="_blank"
              class="facebook"
              ><img
                src="../assets/img/ico-facebook.svg"
                alt="Facebook"
                width="125"
                height="248"
            /></a>
            <a
              href="https://www.instagram.com/ato.inc/"
              target="_blank"
              class="instagram"
              ><img
                src="../assets/img/ico-instagram.svg"
                alt="Instagram"
                width="512"
                height="512"
            /></a>
          </div>
          <div class="privacy">
            <a href="https://www.ato-co.jp/privacy/" target="_blank"
              >個人情報保護方針</a
            >
            <a @click="togglePopupLaw" class="law-button">特定商取引法に基づく表示</a>
          </div>
          <div class="copyright">
            copyright&copy;2024 ato All Right Reserved.
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { authStore } from "../store/auth-store";

export default {
  name: "FooterNew",
  data() {
    return {
      authStore,
      isShowPopupLaw: false,
      footerSrc: require("../assets/imgs/ftr-logo_a.png"),
      heroSrc: require("../assets/imgs/logo_a.png"),
      movSrc: require("../assets/imgs/mv_sp.mp4"),
    };
  },
  methods: {
    togglePopupLaw() {
      this.isShowPopupLaw = !this.isShowPopupLaw
    }
  },
  mounted() {
    jQuery(($) => {
      "use strict";

      const $body = $(".dashboard-page");

      /* ---------- intersectionObserver ---------- */

      let isftrLogoShowed = false;

      const intersectionObserver = new IntersectionObserver(
        (entry) => {
          for (let i = 0; i < entry.length; ++i) {
            const $target = $(entry[i].target);
            const data = $target.attr("data-scroll");

            switch (data) {
              case "hero":
                if (entry[i].isIntersecting) {
                  $body.removeClass("turnHeader");
                } else {
                  $body.addClass("turnHeader");
                }
                break;
              case "ftrLogo":
                if (
                  entry[i].isIntersecting &&
                  entry[i].intersectionRatio >= 0.5
                ) {
                  if (!isftrLogoShowed) {
                    $(".gFooter .logo img").attr(
                      "src",
                      this.footerSrc + "?" + new Date().getTime()
                    );
                    isftrLogoShowed = true;
                  }
                }
                break;
              case "at50":
                if (
                  entry[i].isIntersecting &&
                  entry[i].intersectionRatio >= 0.5
                ) {
                  $target.addClass("scrollIn");
                }
                break;
              default:
                if (entry[i].isIntersecting) {
                  $target.addClass("scrollIn");
                }
            }
          }
        },
        {
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        }
      );

      const intersectionObserverTargets =
        document.querySelectorAll(".watchScroll");

      intersectionObserverTargets.forEach((target) => {
        intersectionObserver.observe(target);
      });

      /* ---------- mv ---------- */

      const $mv = $(".hero");

      if ($mv.length > 0) {
        const $mvMovie = $(".movie", $mv);
        const $mvlogo = $(".logo img", $mv);
        const video = document.getElementById("video");

        const mediaQueryList = window.matchMedia("(max-width: 750px)");

        const handleMediaChange = (ev) => {
          if (ev.matches) {
            video.setAttribute("src", "../assets/img/mv_sp.mp4");
          }
        };

        handleMediaChange(mediaQueryList);

        video.play();

        video.addEventListener("ended", () => {
          $mvMovie.fadeOut(800, () => {
            $mvMovie.remove();
            $mv.addClass("ready");
            $mvlogo.attr(
              "src",
              "../assets/imgs/logo_a.png?" + new Date().getTime()
            );
          });
        });
      }

      /* ---------- misc ---------- */

      const $gNavServiceMenu = $(".gNav .service .menu");

      $(".gNav .service")
        .on("mouseenter", () => {
          $gNavServiceMenu.slideDown();
        })
        .on("mouseleave", () => {
          $gNavServiceMenu.slideUp();
        });

      $(".num .counter").each((index, el) => {
        const $target = $(el);
        const step = parseInt($target.data("step"));
        let number = $target.find(".row").text();
        let text = "";
        number = number.replace(/,/, "");
        number = parseInt(number);

        for (let i = 0; i < 49; i++) {
          number = number - step;
          text = number.toLocaleString();
          console.log(text);
          $("<div>")
            .addClass("row")
            .text(text)
            .prependTo($target.find(".inner"));
        }
      });
    });
  },
};
</script>

<style scoped lang="scss">
// 変数定義
// #############################################################################################
@use "../assets/css/settings" as *;
@use "../assets/css/reset";

// 共通設定
// #############################################################################################

.home {
  height: 50vh;
}
:root {
  font-size: calc(100px / $pcDesignRate);

  @include pcNarrow {
    font-size: calc(100vw * 100 / $pcDesignRate / $pcWidth);
  }

  @include sp {
    font-size: calc(100vw * 100 / $spDesignWidth);
  }
}

.dashboard-page {
  // background-color: red;
  // min-height: 100vh;
  // min-height: 100dvh;
  background: #151515;
  height: max-content;
  color: #fff;
  font-family: $sans;
  font-size: $baseFontSize;
  font-optical-sizing: auto;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: $baseLineHeight;
  // zoom: 3.5;
  overflow: auto;

  @include sp {
    font-size: $baseFontSizeSp;
    line-height: $baseLineHeightSp;
  }
}

// レスポンシブ対応
// ==========================================================================
.wrap {
  // max-width: #{$pcWrappWidth / 100}rem;

  margin: {
    right: auto;
    left: auto;
  }

  @include sp {
    width: auto;

    padding: {
      right: $spPading;
      left: $spPading;
    }
  }
}

.sp {
  display: none;
}

@include sp {
  .pc {
    display: none;
  }

  .sp {
    display: revert;
  }
}

@include pc {
  a[href^="tel:"] {
    pointer-events: none;
  }
}

// アニメーション
// ==========================================================================
.hov {
  @extend %hov;
}

.fadeUp {
  opacity: 0;
  transform: translate3d(0, 1rem, 0);
  transition: 0.8s;
  transition-property: opacity, transform;

  &.scrollIn {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

// #common
// #############################################################################################
.btn {
  &--01 {
    overflow: hidden;
    background-image: linear-gradient(90deg, #a3c436, #75888a, #a3c436);
    background-position: 0 0;
    background-size: 200% 100%;
    background-repeat: no-repeat;

    @include hover {
      transition: background-position 0.4s;

      &:hover {
        background-position: 100% 0;
      }
    }
  }
}

// #header
// #############################################################################################
.gHeader {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;
  transition: background-color 0.4s;

  @include sp {
    align-items: center;
    height: 1.58rem;
  }

  &::before {
    content: "";
    display: block;
    width: 4.86rem;
    height: 0.9rem;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, #a3c436, #75888a);
    clip-path: polygon(0 0, 100% 0, calc(100% - 0.64rem) 100%, 0 100%);
    opacity: 0;
    transition: opacity 0.4s;

    @include sp {
      content: none;
    }
  }

  .dashboard-page.turnHeader &,
  .dashboard-page.login & {
    align-items: center;
    height: 0.9rem;
    background: #191919;

    @include sp {
      height: 1.58rem;
    }

    &::before {
      opacity: 1;
    }
  }

  // branding
  // ==========================================================================
  .branding {
    box-sizing: border-box;
    width: 1.95rem;
    padding: 0.5rem 0 0 0.5rem;
    position: relative;
    z-index: +1;
    font-size: 1px;
    line-height: 1;
    transition: padding 0.4s;

    @include sp {
      padding: 0 0 0 0.5rem;
    }

    .dashboard-page.turnHeader &,
    .dashboard-page.login & {
      padding: 0 0 0 0.5rem;
    }
  }

  // navigation
  // ==========================================================================
  .gNav {
    $barBoxWidth: 0.24rem;
    $barBoxHeight: 0.22rem;
    $barHeight: 0.03rem;
    $barColor: #fff;

    @include sp {
      display: flex;
      align-items: center;
      gap: 0.2rem;
      padding: 0 0.4rem 0 0;
    }

    .btn--menu {
      display: grid;
      place-items: center;
      width: 0.78rem;
      height: 0.78rem;
      position: relative;
      z-index: +1;
      border-radius: 50%;
      box-shadow: inset 0 0 0 0.02rem #fff;

      @include pc {
        display: none;
      }

      input,
      .bar {
        grid-area: 1/1;
      }

      input {
        visibility: hidden;
      }

      .bar {
        display: grid;
        width: $barBoxWidth;
        height: $barBoxHeight;
        background-image: linear-gradient($barColor, $barColor);
        background-position: 50% 50%;
        background-size: 100% $barHeight;
        background-repeat: no-repeat;
        transition: background-size 0.2s;

        &::before,
        &::after {
          content: "";
          display: block;
          height: $barHeight;
          grid-area: 1/1;
          align-self: center;
          justify-self: stretch;
          background: $barColor;
          transition: transform 0.2s;
        }

        &::before {
          transform: translate3D(
            0,
            #{calc($barBoxHeight / -2)} + #{calc($barHeight / 2)},
            0
          );
        }

        &::after {
          transform: translate3D(
            0,
            #{calc($barBoxHeight / 2)} - #{calc($barHeight / 2)},
            0
          );
        }
      }
    }

    &:has(.btn--menu input:checked) {
      .btn--menu {
        .bar {
          background-size: 0 $barHeight;

          &::before {
            transform: translate3D(0, 0, 0) rotate(135deg);
          }

          &::after {
            transform: translate3D(0, 0, 0) rotate(45deg);
          }
        }
      }

      .navigation {
        .spMenu {
          translate: 0 0 0;
        }
      }
    }

    // ==========================================================================
    .navigation {
      padding: 0.46rem 0.5rem 0 0;
      transition: padding 0.4s;

      @include sp {
        padding: 0;
      }

      .list {
        display: flex;

        @include sp {
          gap: 0.16rem;
        }

        li {
          margin: 0 0 0 0.2rem;

          @include sp {
            margin: 0;
          }

          &:nth-child(-n + 3) {
            margin: 0 0 0 0.3rem;

            @include sp {
              margin: 0;
            }
          }
        }

        a {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 0.52rem;
          font-size: 0.16rem;
          letter-spacing: 0.06em;
          line-height: 1;

          @include sp {
            height: 0.62rem;
            font-size: 0.2rem;
          }

          i {
            display: block;
            background: 0 0 / contain no-repeat;

            @include sp {
              display: none;
            }
          }
        }

        .guide {
          gap: 0.14rem;

          @include sp {
            display: none;
          }

          i {
            width: 0.18rem;
            height: 0.18rem;
            background-image: url(../assets/img/ico-guide.svg);
          }
        }

        .faq {
          gap: 0.1rem;

          @include sp {
            display: none;
          }

          i {
            width: 0.2rem;
            height: 0.2rem;
            background-image: url(../assets/img/ico-faq.svg);
          }
        }

        .map {
          gap: 0.12rem;
          box-sizing: border-box;
          width: 2.14rem;
          padding: 0 0.1rem 0 0;
          border-radius: 0.26rem;
          box-shadow: inset 0 0 0 1px #fff;

          @include sp {
            display: none;
          }

          i {
            width: 0.15rem;
            height: 0.2rem;
            background-image: url(../assets/img/ico-map.svg);
          }
        }

        .entry,
        .status {
          gap: 0.12rem;
          box-sizing: border-box;
          border-radius: 0.26rem;
          box-shadow: inset 0 0 0 1px #fff;

          @include sp {
            width: 1.64rem;
            padding: 0;
            border-radius: 0.61rem;
          }

          i {
            width: 0.1rem;
            height: 0.1rem;
            background: #a3c436;
            border-radius: 50%;
          }
        }

        .entry {
          width: 2.14rem;
          padding: 0 0.1rem 0 0;

          @include sp {
            width: 1.64rem;
            padding: 0;
          }
        }

        .status {
          width: 2.3rem;

          @include sp {
            display: none;
          }
        }

        .cart {
          display: block;
          width: 0.33rem;
          background: url(../assets/img/ico-cart.svg) 0 50% / 100% auto
            no-repeat;
          position: relative;
          z-index: +1;
        }

        .login {
          display: grid;
          place-items: center;
          width: 1.44rem;
          border-radius: 0.26rem;

          @include sp {
            width: 1.24rem;
            border-radius: 0.32rem;
          }
        }
      }

      .spMenu {
        display: none;

        @include sp {
          display: block;
          box-sizing: border-box;
          width: 100vw;
          height: 100vh;
          padding: 1.66rem 1.5rem 1.1rem;
          position: absolute;
          top: 0;
          left: 0;
          background: #151515;
          overflow-y: scroll;
          translate: 100% 0 0;
          transition: translate 0.4s;

          .toc {
            a {
              display: block;
              font-size: 0.3rem;
              line-height: calc(96 / 30);
              padding: 0 0 0 1.38rem;

              &.map {
                background: url(../assets/img/ico-map.svg) 0.82rem 50% / 0.25rem
                  auto no-repeat;
              }

              &.guide {
                background: url(../assets/img/ico-guide2.svg) 0.73rem 50% /
                  0.43rem auto no-repeat;
              }

              &.faq {
                background: url(../assets/img/ico-faq2.svg) 0.77rem 50% /
                  0.35rem auto no-repeat;
              }

              &.contact {
                background: url(../assets/img/ico-contact.svg) 0.76rem 50% /
                  0.37rem auto no-repeat;
              }

              .dashboard-page.login & {
                padding: 0 0 0 0.94rem;

                &.map {
                  background-position: 0.37rem 50%;
                }

                &.status {
                  background: url(../assets/img/ico-status.svg) 0.33rem 50% /
                    0.34rem auto no-repeat;
                }

                &.myacount {
                  background: url(../assets/img/ico-myacount.svg) 0.3rem 50% /
                    0.4rem auto no-repeat;
                }

                &.guide {
                  background-position: 0.28rem 50%;
                }

                &.faq {
                  background-position: 0.32rem 50%;
                }

                &.contact {
                  background-position: 0.31rem 50%;
                }

                &.all {
                  background: url(../assets/img/ico-all.svg) 0.35rem 50% /
                    0.29rem auto no-repeat;
                }
              }
            }
          }

          .member {
            margin: 0.62rem 0 0;

            li {
              margin: 0.28rem 0 0;
            }

            a {
              display: grid;
              place-items: center;
              height: 0.92rem;
              border-radius: 0.46rem;
              font-size: 0.24rem;

              &.entry {
                box-shadow: inset 0 0 0 0.02rem #fff;
              }
            }
          }
        }
      }

      // ==========================================================================

      .dashboard-page.turnHeader & {
        padding: 0 0.5rem 0 0;

        @include sp {
          padding: 0;
        }
      }

      .dashboard-page.login & {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        padding: 0 0.5rem 0 0;

        @include sp {
          padding: 0;
        }

        .service {
          width: 2.55rem;
          position: relative;

          @include sp {
            display: none;
          }

          .button {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 0.08rem;
            height: 0.52rem;
            cursor: pointer;
          }

          .name {
            font-size: 0.16rem;
            font-weight: 400;
            line-height: 1;
          }

          .label {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0.23rem;
            line-height: 1;

            &::after {
              content: "";
              display: block;
              width: 0.21rem;
              height: 0.21rem;
              background: url(../assets/img/arw3.svg) 50% 50% / 0.07rem auto
                no-repeat;
              border-radius: 50%;
              box-shadow: inset 0 0 0 1px #fff;
            }
          }

          .menu {
            display: none;
            width: 100%;
            padding: 0.24rem 0 0;
            position: absolute;
            top: 100%;
            left: 0;

            ul {
              padding: 0.2rem 0 0.2rem 0.3rem;
              background: #fff;
              border-radius: 0.1rem;
              color: #000;
              font-size: 0.16rem;
              font-weight: 400;
              line-height: calc(36 / 16);
            }

            @include hover {
              a:hover {
                color: #a3c436;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
  }
}

// #main
// #############################################################################################
.main-dashboard {
  // #units
  // ==========================================================================
  .ttl {
    width: fit-content;
    padding: 0 0.45rem;
    background: linear-gradient(90deg, #a3c436, #75888a);
    font-size: 0.34rem;
    line-height: 0.6rem;
    clip-path: polygon(0.3rem 0, 100% 0, calc(100% - 0.3rem) 100%, 0 100%);

    @include sp {
      font-size: 0.3rem;
    }

    .small {
      font-size: 0.3rem;
    }
  }

  .catch {
    @extend %textCrop;
    font-size: 0.5rem;
    line-height: calc(68 / 50);

    @include sp {
      font-size: 0.7rem;
      line-height: calc(10 / 7);
    }
  }

  p {
    @extend %textCrop;

    strong {
      background: linear-gradient(90deg, #a3c436, #75888a);
      color: transparent;
      font-weight: inherit;
      background-clip: text;
    }
  }

  // home
  // ==========================================================================
  .dashboard-page.home & {
    .hero {
      display: grid;
      height: 100vh;
      overflow: hidden;

      .bg,
      .logo,
      .text,
      .corner,
      .movie {
        grid-area: 1/1;
      }

      .bg {
        overflow: hidden;

        img {
          width: 100%;
          height: 100vh;
          object-fit: cover;
          opacity: 0;
          filter: blur(0.2rem);
        }
      }

      .logo {
        justify-self: center;
        align-self: flex-end;
        width: 19.2rem;
        max-width: none;
        margin: 0 0 1.35rem;
        position: relative;
        opacity: 0;

        @include sp {
          width: calc((6rem / 15) * 19.2);
          margin: 0 0 2rem;
        }

        img {
          width: 100%;
        }
      }

      .text {
        margin: 0 0 0.32rem;
        justify-self: center;
        align-self: flex-end;
        position: relative;
        font-size: 0.36rem;
        line-height: 1;
        letter-spacing: 0.06em;

        @include sp {
          margin: 0 0 0.6rem;
          font-size: 0.3rem;
        }
      }

      .corner {
        display: grid;
        width: 5.65rem;
        height: 7.96rem;
        position: relative;
        clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);

        @include sp {
          width: 4.6rem;
          height: 5.55rem;
        }

        &::before {
          content: "";
          grid-area: 1/1;
          background: linear-gradient(90deg, #a3c436, #75888a);
          opacity: 0.7;
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }
      }

      .movie {
        background: #151515;
        position: relative;
        z-index: 9900;

        video {
          display: block;
          width: 100%;
          height: 100vh;
          object-fit: cover;

          @include sp {
          }
        }
      }

      &.ready {
        .bg {
          img {
            opacity: 1;
            filter: blur(0);
            transition: 1.2s;
            transition-property: opacity, filter;
          }
        }

        .logo {
          animation: showLogo 0.4s linear both;

          @keyframes showLogo {
            from {
              opacity: 0;
            }

            to {
              opacity: 1;
            }
          }
        }

        .corner {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
          transition: clip-path 0.8s 0.4s;
        }
      }
    }

    .feature {
      padding: 1.8rem 0 2.04rem;
      position: relative;

      @include sp {
        padding: 1.8rem 0 0;
      }

      .line {
        display: grid;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);

        &::before {
          content: "";
          grid-area: 1/1;
          background: #191919;
          clip-path: polygon(0 calc(100% - 7rem), 100% 100%, 0 100%);
        }
      }

      .text {
        display: flex;
        justify-content: space-between;

        @include sp {
          display: block;
        }

        p {
          width: 9.2rem;
          line-height: calc(58 / 26);

          @include sp {
            width: auto;
            padding: 0.8rem 0 0;
          }
        }
      }

      .list {
        display: flex;
        justify-content: space-between;
        margin: 1rem 0 0;

        @include sp {
          flex-wrap: wrap;
          justify-content: flex-start;
          margin: 0.8rem 0 0;
          border-top: 0.02rem solid #8ba66c;

          &::after {
            content: "";
            display: block;
            box-sizing: border-box;
            width: calc(100% / 3);
            height: 2.58rem;
            border-bottom: 0.02rem solid #8ba66c;
            background: url(../assets/img/logo.svg) 50% 50% / 1.3rem auto
              no-repeat;
            scale: 1 0;
            transform-origin: top;
            transition-delay: 1s;
          }
        }

        .item {
          box-sizing: border-box;
          width: 2.68rem;
          height: 2.8rem;
          border: 0.02rem solid;
          border-image: linear-gradient(#75888a, #a3c436);
          border-image-slice: 1;
          padding: 1.96rem 0 0;
          font-size: 0.22rem;
          line-height: 1;
          text-align: center;
          scale: 1 0;
          transform-origin: top;

          @include sp {
            width: calc(100% / 3);
            height: 2.58rem;
            border-top: none;
            border-right: none;
            border-bottom: 0.02rem solid #8ba66c;
            border-left: none;
            padding: 1.56rem 0 0;
            line-height: calc(32 / 22);
          }

          &--01 {
            background: url(../assets/img/fig01.png) 50% 0.56rem / 0.8rem auto
              no-repeat;

            @include sp {
              background-image: linear-gradient(#75888a, #a3c436),
                url(../assets/img/fig01.png);
              background-position: 100% 50%, 50% 0.41rem;
              background-size: 0.02rem 2rem, 0.71rem auto;
            }
          }

          &--02 {
            background: url(../assets/img/fig02.png) 50% 0.63rem / 0.74rem auto
              no-repeat;
            transition-delay: 0.2s;

            @include sp {
              background-image: linear-gradient(#75888a, #a3c436),
                url(../assets/img/fig02.png);
              background-position: 100% 50%, 50% 0.43rem;
              background-size: 0.02rem 2rem, 0.66rem auto;
            }
          }

          &--03 {
            background: url(../assets/img/fig03.png) calc(50% - 0.07rem) 0.55rem /
              0.91rem auto no-repeat;
            transition-delay: 0.4s;

            @include sp {
              background-position: 50% 0.38rem;
              background-size: 0.81rem auto;
            }
          }

          &--04 {
            background: url(../assets/img/fig04.png) 50% 0.69rem / 0.89rem auto
              no-repeat;
            transition-delay: 0.6s;

            @include sp {
              background-image: linear-gradient(#75888a, #a3c436),
                url(../assets/img/fig04.png);
              background-position: 100% 50%, 50% 0.45rem;
              background-size: 0.02rem 2rem, 0.78rem auto;
            }
          }

          &--05 {
            background: url(../assets/img/fig05.png) 50% 0.69rem / 0.83rem auto
              no-repeat;
            transition-delay: 0.8s;

            @include sp {
              background-image: linear-gradient(#75888a, #a3c436),
                url(../assets/img/fig05.png);
              background-position: 100% 50%, 50% 0.5rem;
              background-size: 0.02rem 2rem, 0.72rem auto;
            }
          }
        }

        &.scrollIn {
          .item {
            scale: 1 1;
            transition-property: scale;
            transition-duration: 0.4s;
          }

          &::after {
            scale: 1 1;
            transition-property: scale;
            transition-duration: 0.4s;
          }
        }
      }

      &.scrollIn {
        .line {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
          transition: clip-path 1.2s;
        }

        & + .posting {
          .line {
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            transition: clip-path 1.2s;
          }
        }
      }
    }

    .posting,
    .newspaper,
    .dsp {
      position: relative;
      overflow: hidden;

      .line {
        display: grid;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;

        &::before {
          content: "";
          grid-area: 1/1;
          background: #191919;
        }
      }

      .wrap {
        position: relative;
      }

      .catch {
        padding: 0.4rem 0 0;
      }

      .image {
        display: grid;
        position: absolute;
        transition: translate 0.4s;

        @include sp {
          position: relative;
        }

        &::before,
        &::after {
          content: "";
          grid-area: 1/1;
          display: block;
          z-index: -1;
          background: 0 0 / cover no-repeat;
          transition: clip-path 0.4s;
        }

        img {
          grid-area: 1/1;
          opacity: 0;
          transition: opacity 0.4s;
        }

        &.scrollIn {
          img {
            opacity: 1;
          }
        }
      }

      .num {
        display: flex;
        gap: 0.6rem;

        &--01,
        &--02 {
          display: grid;
          grid-template-rows: auto auto;
          grid-template-columns: auto;
          flex-direction: column;
          gap: 0.4rem;
          height: 1.83rem;
        }

        .name {
          grid-row: 1/2;
          grid-column: 1/2;
          font-size: 0.3rem;
          line-height: 1;
        }

        img {
          grid-row: 2/3;
          grid-column: 1/2;
        }

        .counter {
          grid-row: 2/3;
          grid-column: 1/2;
          align-self: flex-end;
          box-sizing: border-box;
          width: fit-content;
          height: calc(1.3em + 0.2rem);
          color: #a3c436;
          font-family: $en;
          font-size: 1.08rem;
          font-weight: 300;
          letter-spacing: 0;
          line-height: 1.3;
          translate: 0 -0.35rem;
          overflow: hidden;
          text-align: right;

          .row {
            height: 1.3em;
            background: linear-gradient(90deg, #a3c436, #75888a);
            color: transparent;
            font-weight: inherit;
            background-clip: text;
          }
        }

        &.scrollIn {
          .inner {
            animation: countUp 2s steps(49) both;

            @keyframes countUp {
              from {
                translate: 0 0 0;
              }

              to {
                translate: 0 calc((1.3em) * -49) 0;
              }
            }
          }
        }
      }

      p {
        padding: 0.7rem 0 0;

        @include sp {
          padding: 0.8rem 0 0;
        }
      }

      .list {
        display: flex;
        flex-wrap: wrap;
        gap: 0.42rem;

        @include sp {
          gap: 0.2rem;
        }

        li {
          width: 4.72rem;
          scale: 1 0;
          transform-origin: top;

          @include sp {
            width: calc(50% - 0.1rem);
          }

          &:nth-child(2) {
            transition-delay: 0.2s;
          }

          &:nth-child(3) {
            transition-delay: 0.4s;
          }

          &:nth-child(4) {
            transition-delay: 0.6s;
          }

          &:nth-child(5) {
            transition-delay: 0.8s;
          }

          &:nth-child(6) {
            transition-delay: 1s;
          }
        }

        &.scrollIn {
          li {
            scale: 1 1;
            transition-property: scale;
            transition-duration: 0.4s;
          }
        }
      }
    }

    .posting {
      padding: 0.4rem 0 0;

      @include sp {
        padding: 1.8rem 0 0;
      }

      .line {
        clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);

        &::before {
          clip-path: polygon(0 0, 100% 0, 100% 9.3rem, 0 1.5rem);
        }
      }

      .num {
        margin: 0.96rem 0 0;

        @include sp {
          margin: 0.8rem 0 0;

          .inner {
            transform: translate(0, 0.1rem);
          }
        }

        &--01 {
          width: 2rem;
        }

        &--02 {
          width: 3.6rem;
        }
      }

      .image {
        width: 11.02rem;
        top: 0.34rem;
        right: -2rem;
        translate: calc(100% * 174 / 1102) 0 0;

        @include sp {
          width: auto;
          margin: 0.4rem -0.4rem 0;
          top: 0;
          right: 0;
          translate: none;
        }

        &::before {
          background-image: url(../assets/img/img01_bg.png),
            linear-gradient(90deg, #a3c436, #75888a);
          clip-path: polygon(
            #{calc(100% * 308 / 1102)} #{calc(100% * 74 / 786)},
            #{calc(100% * 896 / 1102)} #{calc(100% * 74 / 786)},
            #{calc(100% * 896 / 1102)} 100%,
            #{calc(100% * 308 / 1102)} 100%
          );
        }

        &::after {
          content: none;
        }

        &.scrollIn {
          translate: 0 0 0;

          &::before {
            clip-path: polygon(
              #{calc(100% * 432 / 1102)} #{calc(100% * 74 / 786)},
              #{calc(100% * 1020 / 1102)} #{calc(100% * 74 / 786)},
              #{calc(100% * 672 / 1102)} 100%,
              #{calc(100% * 84 / 1102)} 100%
            );
          }
        }
      }

      .list {
        margin: 2.06rem 0 0;

        @include sp {
          margin: 0.8rem 0 0;
        }
      }

      .note {
        @extend %textCrop;
        padding: 0.46rem 0 0;
        color: #777;
        font-size: 0.16rem;
        font-weight: 400;
        line-height: 1.4;
        text-align: center;

        @include sp {
          padding: 0.4rem 0 0;
          font-size: 0.2rem;
          text-align: left;
        }
      }
    }

    .newspaper {
      padding: 1.9rem 0 1.84rem;

      @include sp {
        padding: 1.8rem 0 0;
      }

      .line {
        clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%);

        &::before {
          clip-path: polygon(100% calc(100% - 7.06rem), 100% 100%, 0 100%);
        }
      }

      .ttl {
        margin: 0 0 0 7.4rem;

        @include sp {
          margin: 0;
        }
      }

      .catch {
        margin: 0 0 0 7.4rem;

        @include sp {
          margin: 0;
        }
      }

      .image {
        width: 8.79rem;
        top: 0.67rem;
        left: -2rem;
        translate: calc(100% * -1.74 / 879) 0 0;

        @include sp {
          width: auto;
          margin: 0.4rem -0.4rem 0;
          left: 0;
        }

        &::before {
          background-image: linear-gradient(90deg, #a3c436, #75888a);
          clip-path: polygon(
            #{calc(100% * 150 / 879)} #{calc(100% * 327 / 615)},
            #{calc(100% * 560 / 879)} #{calc(100% * 327 / 615)},
            #{calc(100% * 560 / 879)} 100%,
            #{calc(100% * 150 / 879)} 100%
          );
        }

        &::after {
          background-image: url(../assets/img/img02_bg.png),
            linear-gradient(90deg, #a3c436, #75888a);
          clip-path: polygon(
            #{calc(100% * 118 / 879)} #{calc(100% * 15 / 615)},
            #{calc(100% * 706 / 879)} #{calc(100% * 15 / 615)},
            #{calc(100% * 706 / 879)} #{calc(100% * 487 / 615)},
            #{calc(100% * 118 / 879)} #{calc(100% * 487 / 615)}
          );
        }

        &.scrollIn {
          translate: 0 0 0;

          &::before {
            clip-path: polygon(
              #{calc(100% * 28 / 879)} #{calc(100% * 327 / 615)},
              #{calc(100% * 438 / 879)} #{calc(100% * 327 / 615)},
              #{calc(100% * 682 / 879)} 100%,
              #{calc(100% * 272 / 879)} 100%
            );
          }

          &::after {
            clip-path: polygon(
              #{calc(100% * -55 / 879)} #{calc(100% * 15 / 615)},
              #{calc(100% * 532 / 879)} #{calc(100% * 15 / 615)},
              #{calc(100% * 879 / 879)} #{calc(100% * 487 / 615)},
              #{calc(100% * 292 / 879)} #{calc(100% * 487 / 615)}
            );
          }
        }
      }

      .num {
        flex-direction: column;
        margin: 0.96rem 0 0 7.4rem;
        gap: 0.34rem;

        @include sp {
          gap: 0.3rem;
        }

        @include sp {
          margin: 0.8rem 0 0;

          .inner {
            transform: translate(0, 0.1rem);
          }
        }

        &--01 {
          width: 5.5rem;

          .counter {
            margin: 0 0 0 0.55rem;
          }
        }

        .note {
          padding: 0.12rem 0 0;
          font-size: 0.14rem;
          font-weight: 400;
          line-height: 1;

          @include sp {
            padding: 0.2rem 0 0;
            font-size: 0.2rem;
          }
        }
      }

      p {
        text-align: center;

        @include sp {
          text-align: left;
        }
      }

      .list {
        margin: 0.8rem 0 0;

        @include sp {
          li {
            width: calc((100% - 0.4rem) / 3);
          }
        }
      }

      &.scrollIn {
        .line {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
          transition: clip-path 1.2s;
        }

        & + .dsp {
          .line {
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            transition: clip-path 1.2s;
          }
        }
      }
    }

    .dsp {
      @include sp {
        padding: 1.8rem 0 0;
      }

      .line {
        clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%);

        &::before {
          clip-path: polygon(0 0, 100% 0, 100% 1.5rem, 0 9.26rem);
        }
      }

      .image {
        width: 9.08rem;
        top: 0;
        right: -2rem;
        translate: calc(100% * 175 / 908) 0 0;

        @include sp {
          width: auto;
          margin: 0.4rem -0.4rem 0;
          top: 0;
          right: 0;
          translate: none;
        }

        &::before {
          background-image: url(../assets/img/img03_bg.png),
            linear-gradient(90deg, #a3c436, #75888a);
          clip-path: polygon(
            #{calc(100% * 175 / 908)} 0,
            #{calc(100% * 673 / 908)} 0,
            #{calc(100% * 673 / 908)} 100%,
            #{calc(100% * 175 / 908)} 100%
          );
        }

        &::after {
          content: none;
        }

        &.scrollIn {
          translate: 0 0 0;

          &::before {
            clip-path: polygon(
              #{calc(100% * 350 / 908)} 0,
              #{calc(100% * 938 / 908)} 0,
              #{calc(100% * 588 / 908)} 100%,
              0 100%
            );
          }
        }
      }

      .num {
        margin: 0.96rem 0 0;

        @include sp {
          margin: 0.8rem 0 0;

          .counter {
            font-size: 1rem;
          }
        }

        &--01 {
          width: 3.52rem;
        }

        &--02 {
          width: 3.7rem;
        }
      }

      .list {
        margin: 1.4rem 0 0;

        @include sp {
          margin: 0.8rem 0 0;

          li {
            width: calc((100% - 0.4rem) / 3);
          }
        }
      }
    }

    .service,
    .megapos,
    .yoff {
      .ttl {
        padding: 0;
        background: none;
        clip-path: none;

        img {
          clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
        }

        &.scrollIn {
          img {
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            transition: clip-path 0.8s;
          }
        }
      }
    }

    .service {
      padding: 4.5rem 0 0;
      position: relative;
      color: #111;
      overflow: hidden;

      @include sp {
        padding: 1.8rem 0 0;
      }

      .line {
        display: grid;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;

        &::before {
          content: "";
          grid-area: 1/1;
        }

        &--01 {
          clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%);

          &::before {
            background: #191919;
            clip-path: polygon(
              0.22rem 7.83rem,
              100% 0.91rem,
              100% 100%,
              0.22rem 100%
            );

            @include sp {
              clip-path: polygon(0 2.8rem, 100% 0, 100% 100%, 0 100%);
            }
          }
        }

        &--02 {
          clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);

          &::before {
            background: #fff;
            clip-path: polygon(0 0.27rem, 100% 7.28rem, 100% 100%, 0 100%);

            @include sp {
              clip-path: polygon(0 0, 100% 2.8rem, 100% 100%, 0 100%);
            }
          }
        }
      }

      .headline {
        display: grid;
        grid-template-rows: auto auto;
        grid-template-columns: auto;
        width: 13.52rem;
        margin: 0 auto;

        @include sp {
          display: block;
          width: auto;
        }

        .ttl {
          grid-row: 1/2;
          grid-column: 1/2;
        }

        .catch {
          grid-column: 1/2;
          text-align: center;

          &--01 {
            grid-row: 1/2;
            align-self: flex-end;
            font-size: 0.4rem;

            @include sp {
              padding: 0.4rem 0 0;
              font-size: 0.6rem;
            }
          }

          &--02 {
            grid-row: 2/3;
            padding: 0.8rem 0 0;
            font-size: 0.26rem;
            line-height: calc(56 / 26);

            @include sp {
              font-size: 0.35rem;
              line-height: calc(75 / 35);
            }
          }
        }
      }

      .point {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: 1fr 6.4rem;
        margin: 1rem 0 0;

        @include sp {
          display: block;
          margin: 0.8rem 0 0;
        }

        .image {
          grid-row: 1/2;
          grid-column: 1/2;
          align-self: flex-start;
          display: grid;
          width: 10.02rem;
          margin: 0 0 0 -2.1rem;
          overflow: hidden;

          @include sp {
            width: auto;
            margin: 0 -0.4rem;
          }

          img {
            grid-area: 1/1;
            opacity: 0;
            translate: -100% 0 0;
            transition: translate 0.8s;
            transition-property: opacity, translate;
          }

          .smp {
            width: 1.43rem;
            align-self: flex-end;
            justify-self: flex-start;
            transition-delay: 0.4s;

            @include sp {
              width: 1rem;
            }
          }

          &.scrollIn {
            img {
              opacity: 1;
              translate: 0 0 0;
            }
          }
        }

        .list {
          grid-row: 1/2;
          grid-column: 2/3;
          margin: 0 -0.3rem 0 0;
          border-bottom: 0.02rem solid #e7e7e7;

          @include sp {
            margin: 0.4rem 0 0;
          }

          li {
            display: flex;
            border-top: 0.02rem solid #e7e7e7;

            .num {
              width: 1.16rem;
              padding: 0.41rem 0 0;
              font-family: $en;
              font-size: 0.2rem;
              font-weight: 300;
              letter-spacing: 0.02em;
              line-height: 1;

              @include sp {
                width: 1.2rem;
                font-size: 0.24rem;
              }
            }

            p {
              width: calc(100% - 1.16rem);
              padding: 0.4rem 0;
              font-size: 0.24rem;
              line-height: calc(39 / 24);

              @include sp {
                width: calc(100% - 1.2rem);
                font-size: 0.3rem;
              }
            }
          }
        }
      }

      .merit {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: 7.3rem 1fr;
        margin: 1.05rem 0 0;

        @include sp {
          display: block;
          margin: 0.8rem 0 0;
        }

        .image {
          grid-row: 1/2;
          grid-column: 2/3;
          width: 9.66rem;
          margin: 0 -2.1rem 0 0;
          clip-path: polygon(
            1.65rem 0,
            10.15rem 0,
            10.15rem 100%,
            1.65rem 100%
          );
          transition: clip-path 0.4s;

          @include sp {
            width: auto;
            margin: 0 -0.4rem;
          }

          img {
            translate: -1.16rem 0 0;
            transition: translate 0.4s;

            @include sp {
            }
          }

          &.scrollIn {
            clip-path: polygon(3.3rem 0, 11.8rem 0, 8.5rem 100%, 0 100%);

            img {
              translate: 0 0 0;
            }
          }
        }

        .list {
          grid-row: 1/2;
          grid-column: 1/2;
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          margin: 0.58rem 0 0;

          @include sp {
            margin: 0.4rem 0 0;
            gap: 0.2rem;
          }

          li {
            display: flex;
            gap: 0.4rem;

            @include sp {
              gap: 0.2rem;
            }

            .image {
              width: 1.4rem;
              margin: 0;
              clip-path: none;

              @include sp {
              }

              img {
                translate: none;
              }
            }

            .text {
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 5.5rem;
              border-top: 0.02rem solid #e7e7e7;
              border-bottom: 0.02rem solid #e7e7e7;

              @include sp {
                width: calc(100% - 1.6rem);
              }

              .name {
                font-size: 0.24rem;
                line-height: 1;

                @include sp {
                  font-size: 0.3rem;
                }
              }

              p {
                padding: 0.2rem 0 0;
                font-size: 0.2rem;
                font-weight: 400;
                line-height: 1.5;

                @include sp {
                  font-size: 0.24rem;
                }
              }
            }
          }
        }
      }

      .update {
        margin: 1.3rem 0 0;

        @include sp {
          margin: 0.8rem 0 0;
        }

        .name {
          display: flex;
          align-items: center;
          gap: 0.26rem;
          font-size: 0.3rem;
          line-height: 1;

          &::before,
          &::after {
            content: "";
            flex-grow: 1;
            display: block;
            height: 1px;
            background: #e7e7e7;
          }
        }

        .list {
          display: flex;
          justify-content: space-between;
          margin: -0.15rem 0 0;
          border: 1px solid #e7e7e7;
          border-top: none;
          padding: 0.5rem 0.6rem 0.6rem;

          @include sp {
            flex-direction: column;
            gap: 0.4rem;
            padding: 0.5rem 0.4rem 0.4rem;
          }

          li {
            @extend %textCrop;
            width: 4.24rem;
            padding: 0.5rem 0 0;
            background: url(../assets/img/blt-check.png) 0 0 / 0.31rem auto
              no-repeat;
            font-size: 0.22rem;
            font-weight: 400;
            line-height: (calc(36 / 22));

            @include sp {
              width: auto;
              padding: 0 0 0 0.5rem;
              font-size: 0.24rem;
              background-position: 0 0.05rem;
            }
          }
        }
      }

      .btn--map {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.24rem;
        width: 4.5rem;
        height: 0.9rem;
        margin: 0.7rem auto 0;
        border-radius: 0.45rem;
        color: #fff;
        font-size: 0.22rem;

        @include sp {
          width: 5rem;
          height: 1.2rem;
          margin: 0.8rem auto 0;
          border-radius: 0.6rem;
          font-size: 0.3rem;
        }

        i {
          width: 0.27rem;
          height: 0.38rem;
          background: url(../assets/img/ico-map_w.svg) 0 0 / contain no-repeat;
        }
      }

      .btn--entry {
        display: none;

        @include sp {
          display: grid;
          box-sizing: border-box;
          width: 5rem;
          height: 1.2rem;
          margin: 0.4rem auto 0;
          padding: 0.02rem;
          border-radius: 0.6rem;
          background: linear-gradient(0deg, #a3c436, #75888a);

          div {
            grid-area: 1/1;
            display: grid;
            place-items: center;
            background: #fff;
            border-radius: 0.56rem;
            font-size: 0.3rem;

            span {
              background: linear-gradient(90deg, #a3c436, #75888a);
              color: transparent;
              font-weight: inherit;
              background-clip: text;
            }
          }
        }
      }

      .bottomLine {
        display: flex;
        align-items: center;
        margin: 1.5rem 0 0;
        height: 0.9rem;
        background: linear-gradient(90deg, #a3c436, #75888a);

        @include sp {
          margin: 1rem 0 0;
        }

        &::before {
          content: "Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  Analog Digital Transformation.  ";
          color: #fff;
          font-family: $en;
          font-size: 0.3rem;
          font-weight: 300;
          letter-spacing: 0.06em;
          white-space: nowrap;
          animation: ticker 60s infinite linear;

          @keyframes ticker {
            from {
              translate: 0 0 0;
            }

            to {
              translate: -50% 0 0;
            }
          }
        }
      }

      &.scrollIn {
        .line {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
          transition: clip-path 1.2s;
        }
      }
    }

    .megapos {
      padding: 2rem 0 0;

      @include sp {
        padding: 1.8rem 0 0;
      }

      .headline {
        display: grid;
        grid-template-rows: auto auto;
        grid-template-columns: auto;
        margin: 0 -0.95rem 0 -0.94rem;

        @include sp {
          display: block;
          margin: 0;
        }

        .ttl {
          grid-row: 1/2;
          grid-column: 1/2;
        }

        .catch {
          grid-column: 1/2;
          text-align: center;

          &--01 {
            grid-row: 1/2;
            align-self: flex-end;
            font-size: 0.3rem;
            line-height: (calc(48 / 30));

            @include sp {
              padding: 0.4rem 0 0;
              font-size: 0.35rem;
              line-height: (calc(75 / 35));
            }
          }

          &--02 {
            grid-row: 2/3;
            padding: 0.5rem 0 0;
            font-size: 0.5rem;

            @include sp {
            }
          }
        }
      }

      .dashboard-page {
        display: grid;
        grid-template-rows: auto 1fr;
        grid-template-columns: 6.2rem 1fr;
        gap: 1rem 1.3rem;
        margin: 1.1rem 0 0;

        @include sp {
          display: block;
          margin: 0.8rem 0 0;
        }

        .image {
          grid-row: 1/3;
          grid-column: 1/2;
          display: grid;
          grid-template-rows: auto;
          grid-template-columns: 1fr 1fr;
          gap: 0.4rem;

          &--01,
          &--02 {
            grid-row: 1/2;
            align-self: flex-start;
            clip-path: polygon(
              0 0.85rem,
              100% 0.85rem,
              100% calc(100% - 0.85rem),
              0 calc(100% - 0.85rem)
            );
            transition: clip-path 0.4s;
          }

          &--01 {
            grid-column: 1/2;
          }

          &--02 {
            grid-column: 2/3;
            transition-delay: 0.4s;
          }

          .catch {
            grid-row: 1/2;
            grid-column: 1/3;
            align-self: flex-end;
            font-size: 0.6rem;
            line-height: (calc(85 / 60));
            position: relative;
          }

          &.scrollIn {
            .image {
              &--01,
              &--02 {
                clip-path: polygon(
                  0 1.7rem,
                  100% 0,
                  100% calc(100% - 1.7rem),
                  0 100%
                );
              }
            }
          }
        }

        .text {
          grid-row: 1/2;
          grid-column: 2/3;
          font-size: 0.22rem;
          font-weight: 100;
          line-height: (calc(56 / 22));

          @include sp {
            padding: 0.4rem 0 0;
            font-size: 0.24rem;
          }
        }

        .merit {
          grid-row: 2/3;
          grid-column: 2/3;
          padding: 0 0 0.2rem;

          @include sp {
            margin: 0.8rem 0 0;
            padding: 0;
          }

          .name {
            display: flex;
            align-items: center;
            gap: 0.2rem;
            font-size: 0.3rem;
            line-height: 1;

            &::before {
              content: "";
              display: block;
              width: 0.1rem;
              height: 0.1rem;
              background: #a3c436;
              border-radius: 50%;
            }
          }

          .figure {
            height: 4.86rem;
            margin: 0.5rem 0 0;
            position: relative;
            scale: 0.5;
            transition: scale 0.8s;

            @include sp {
              height: 4rem;
            }

            img {
              width: 2.8rem;
              position: absolute;

              @include sp {
                width: 2.3rem;
              }
            }

            .fig {
              &--01 {
                top: 0;
                left: 0;
              }

              &--02 {
                top: 0;
                left: calc(50% - 1.4rem);

                @include sp {
                  left: calc(50% - 1.15rem);
                }
              }

              &--03 {
                top: 0;
                right: 0;
              }

              &--04 {
                bottom: 0;
                left: 1.18rem;

                @include sp {
                  left: 0.94rem;
                }
              }

              &--05 {
                right: 1.18rem;
                bottom: 0;

                @include sp {
                  right: 0.94rem;
                }
              }
            }

            &.scrollIn {
              scale: 1;
            }
          }
        }
      }

      .btn--detail {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.24rem;
        box-sizing: border-box;
        width: 3.7rem;
        height: 0.9rem;
        margin: 0.5rem auto 0;
        padding: 0 0.2rem 0 0;
        border-radius: 0.45rem;
        color: #fff;
        font-size: 0.22rem;

        @include sp {
          width: 5rem;
          height: 1.2rem;
          margin: 0.8rem auto 0;
          padding: 0;
          border-radius: 0.6rem;
          font-size: 0.3rem;
        }

        i {
          width: 0.31rem;
          height: 0.31rem;
          background: url(../assets/img/ico-ext.svg) 0 0 / contain no-repeat;
        }
      }
    }

    .yoff {
      padding: 0.4rem 0 2rem;

      @include sp {
        padding: 1.8rem 0;
      }

      .wrap {
        display: grid;
        grid-template-rows: 1fr auto;
        grid-template-columns: 1fr 6.47rem;
        gap: 0.8rem 0;

        @include sp {
          display: block;
        }
      }

      .headline {
        grid-row: 1/2;
        grid-column: 1/2;
        align-self: flex-end;
        display: grid;
        width: 8.23rem;

        @include sp {
          display: block;
          width: auto;
        }

        .ttl {
          grid-area: 1/1;
        }

        .catch {
          grid-area: 1/1;
          align-self: flex-end;
          font-size: 0.3rem;
          line-height: (calc(48 / 30));

          @include sp {
            padding: 0.4rem 0 0;
          }
        }
      }

      .image {
        grid-row: 1/3;
        grid-column: 2/3;
        clip-path: polygon(
          0 1.1rem,
          100% 1.1rem,
          100% calc(100% - 1.1rem),
          0 calc(100% - 1.1rem)
        );
        transition: clip-path 0.4s;

        &.scrollIn {
          clip-path: polygon(
            0 2.2rem,
            100% 0,
            100% calc(100% - 2.2rem),
            0 100%
          );
        }
      }

      .text {
        grid-row: 2/3;
        grid-column: 1/2;
        align-self: flex-end;
        padding: 0 0 0.64rem;

        @include sp {
          padding: 1rem 0 0;
        }

        .catch {
          .line {
            @extend %textCrop;

            &--01 {
              font-size: 0.28rem;
            }

            &--02 {
              padding: 0.2rem 0 0;
              font-size: 0.5rem;
            }
          }
        }

        p {
          max-width: 6.8rem;
          padding: 0.6rem 0 0;
          font-size: 0.22rem;
          font-weight: 100;
          line-height: (calc(56 / 22));

          @include sp {
            max-width: none;
            font-size: 0.24rem;
          }
        }

        .btn--detail {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.24rem;
          box-sizing: border-box;
          width: 3.7rem;
          height: 0.9rem;
          margin: 0.7rem 0 0;
          padding: 0 0.2rem 0 0;
          border-radius: 0.45rem;
          color: #fff;
          font-size: 0.22rem;

          @include sp {
            width: 5rem;
            height: 1.2rem;
            margin: 0.8rem auto 0;
            padding: 0;
            border-radius: 0.6rem;
            font-size: 0.3rem;
          }

          i {
            width: 0.31rem;
            height: 0.31rem;
            background: url(../assets/img/ico-ext.svg) 0 0 / contain no-repeat;
          }
        }
      }
    }
  }

  // login
  // ==========================================================================
  .dashboard-page.login & {
    // margin: .9rem 0 0;

    @include sp {
      margin: 1.58rem 0 0;
    }
    // service start rem

    .serviceMenu {
      background: #fff;
      color: #1111;

      .wrap {
        max-width: calc(13.5rem * 4);
      }

      .primary {
        padding: calc(1.1rem * 4) 0;
        background: #f6f6f6;

        @include sp {
          padding: calc(1rem * 4) 0;
        }

        .wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;

          @include sp {
            display: block;
          }
        }

        .map {
          box-sizing: border-box;
          width: calc(8.4rem * 4);
          height: calc(5rem * 4);
          padding: calc(4.1rem * 4) 0 0;
          position: relative;
          background-image: url(../assets/img/img-map.jpg),
            linear-gradient(#fff calc(4.1rem * 4), #212121 calc(4.1rem * 4));
          background-position: 50% 0.9rem, 0 0;
          background-size: calc(4.14rem * 4) auto, cover;
          background-repeat: no-repeat;
          border-radius: calc(0.16rem * 4);
          color: #fff;
          font-size: calc(0.24rem * 4);
          line-height: calc(0.9rem * 4);
          text-align: center;
          box-shadow: calc(0.07rem * 4) calc(0.07rem * 4) calc(0.24rem * 4)
            calc(0.06rem * 4) rgba(0, 0, 0, 0.02);

          @include sp {
            display: block;
            width: auto;
            font-size: calc(0.3rem * 4);
          }

          i {
            display: block;
            width: calc(0.36rem * 4);
            height: calc(0.36rem * 4);
            position: absolute;
            right: calc(0.3rem * 4);
            bottom: calc(0.27rem * 4);
            background: url(../assets/img/arw2_r.svg) 0 0 / contain no-repeat;
          }
        }

        .status {
          width: calc(4.6rem * 4);

          @include sp {
            width: auto;
            margin: calc(0.8rem * 4) 0 0;
          }

          .label {
            color: #111;
            font-size: calc(0.3rem * 4);
            line-height: 1;
            text-align: center;

            @include sp {
              font-size: calc(0.36rem * 4);
            }
          }

          .list {
            margin: calc(0.5rem * 4) 0 0;

            li {
              margin: calc(0.3rem * 4) 0 0;
            }

            a {
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              width: 100%;
              height: calc(0.9rem * 4);
              padding: 0 0 0 calc(0.4rem * 4);
              position: relative;
              border-radius: calc(0.16rem * 4);
              color: #fff;
              font-size: calc(0.22rem * 4);

              @include sp {
                height: calc(1.2rem * 4);
                font-size: calc(0.3rem * 4);
              }

              i {
                display: block;
                height: 100%;
                position: absolute;
                top: 0;
                background: 0 50% / 100% auto no-repeat;
              }

              &::after {
                content: "";
                display: block;
                width: calc(0.28rem * 4);
                height: calc(0.28rem * 4);
                position: absolute;
                right: calc(0.3rem * 4);
                bottom: calc(0.31rem * 4);
                background: url(../assets/img/arw2.svg) 0 0 / contain no-repeat;

                @include sp {
                  width: calc(0.36rem * 4);
                  height: calc(0.36rem * 4);
                  bottom: calc(50% - calc(0.18rem * 4));
                }
              }

              &.posting {
                i {
                  width: calc(0.44rem * 4);
                  left: calc(0.95rem * 4);
                  background-image: url(../assets/img/ico-posting.svg);
                }
              }

              &.newspaper {
                i {
                  width: calc(0.39rem * 4);
                  left: calc(0.98rem * 4);
                  background-image: url(../assets/img/ico-newspaper.svg);
                }
              }

              &.dsp {
                i {
                  width: calc(0.44rem * 4);
                  left: calc(0.96rem * 4);
                  background-image: url(../assets/img/ico-dsp.svg);
                }
              }
            }
          }
        }
      }

      .secondary {
        padding: calc(1.2rem * 4) 0 calc(1.3rem * 4);
        color: #111;

        @include sp {
          padding: calc(1rem * 4) 0;
        }

        .label {
          font-size: calc(0.3rem * 4);
          line-height: 1;
          text-align: center;

          @include sp {
            font-size: calc(0.36rem * 4);
          }
        }

        .list {
          display: flex;
          justify-content: space-between;
          margin: calc(0.4rem * 4) 0 0;

          &-staff {
            margin-left: 12.5%;
            margin-right: 12.5%;
          }

          @include sp {
            display: block;
            margin: calc(0.5rem * 4) 0 0;
          }

          li {
            width: calc(4.3rem * 4);

            @include sp {
              width: auto;
              margin: calc(0.3rem * 4) 0 0;
            }
          }

          a {
            display: block;
            box-sizing: border-box;
            height: calc(2rem * 4);
            padding: calc(1.3rem * 4) 0 0;
            position: relative;
            background: #fff no-repeat;
            border-radius: calc(0.16rem * 4);
            font-size: calc(0.22rem * 4);
            line-height: 1;
            text-align: center;
            box-shadow: calc(0.07rem * 4) calc(0.07rem * 4) calc(0.24rem * 4)
              calc(0.06rem * 4) rgba(0, 0, 0, 0.04);

            @include sp {
              font-size: calc(0.3rem * 4);
            }

            &::after {
              content: "";
              display: block;
              width: calc(0.28rem * 4);
              height: calc(0.28rem * 4);
              position: absolute;
              right: calc(0.3rem * 4);
              bottom: calc(0.81rem * 4);
              background: url(../assets/img/arw2_r.svg) 0 0 / contain no-repeat;

              @include sp {
                width: calc(0.36rem * 4);
                height: calc(0.36rem * 4);
                bottom: calc(50% - calc(0.18rem * 4));
              }
            }

            &.myacount {
              background-image: url(../assets/img/ico-myacount.svg);
              background-position: 50% calc(0.4rem * 4);
              background-size: calc(0.54rem * 4) auto;
            }

            &.add {
              background-image: url(../assets/img/ico-add.svg);
              background-position: 50% calc(0.46rem * 4);
              background-size: calc(0.54rem * 4) auto;
            }

            &.logout {
              background-image: url(../assets/img/ico-logout.svg);
              background-position: 50% calc(0.43rem * 4);
              background-size: calc(0.59rem * 4) auto;
            }

            &.guide {
              background-image: url(../assets/img/ico-guide2.svg);
              background-position: 50% calc(0.46rem * 4);
              background-size: calc(0.63rem * 4) auto;
            }

            &.faq {
              background-image: url(../assets/img/ico-faq2.svg);
              background-position: 50% calc(0.42rem * 4);
              background-size: calc(0.6rem * 4) auto;
            }

            &.contact {
              background-image: url(../assets/img/ico-contact.svg);
              background-position: 50% calc(0.48rem * 4);
              background-size: calc(0.54rem * 4) auto;
            }
          }

          & + .label {
            margin: calc(1rem * 4) 0 0;
          }
        }

        .banner {
          display: flex;
          justify-content: space-between;
          margin: calc(1.3rem * 4) 0 0;

          @include sp {
            display: block;
            width: calc(4.3rem * 4);
            margin: calc(1rem * 4) auto 0;
          }

          li {
            width: calc(4.3rem * 4);

            @include sp {
              margin: calc(0.3rem * 4) 0 0;
            }
          }

          .text {
            padding: calc(0.12rem * 4) 0 0;
            font-size: calc(0.16rem * 4);
            font-weight: 400;
            line-height: 1;
            letter-spacing: calc(0.06rem * 4);

            @include sp {
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: calc(0.24rem * 4);
              line-height: 1.5;
            }

            i {
              display: inline-block;
              width: calc(0.07rem * 4);
              height: calc(1.5rem * 4);
              margin: 0 0 0 calc(0.08rem * 4) rem;
              background: url(../assets/img/arw4.svg) 0 50% / 100% auto
                no-repeat;
              vertical-align: text-top;

              @include sp {
                width: calc(0.1rem * 4);
              }
            }
          }
        }
      }
      // end service menu
    }
  }
}

// #footer
// #############################################################################################
.gFooter {
  // background-color: red;
  text-align: left;
  // padding-bottom: 2rem;

  // ==========================================================================
  .contact {
    background: #444;
    // background-color: red;
    padding: calc(0.7rem * 4) 0;
    .wrap-footer {
      // background-color: green;
      padding: 3rem;
      width: max-content;
      margin: auto;
      display: flex;
      gap: 4rem;
      @include sp {
        flex-direction: column;
        gap: 1rem;
        padding: 0.5rem;
      }
      // width: 400px !important;
      // background-color: lightblue;
    }
    // .tel,
    // .mail {
    //   margin: auto;
    //   // width: 100%;
    //   // max-width: max-content;
    //   background-color: blue;
    // }
    .tel,
    .mail {
      box-sizing: border-box;
      // width: ;
      height: calc(2.6rem * 4);
      padding-top: calc(0.68rem * 4);

      @include sp {
        // display: grid;
        // width: auto;
        height: calc(1.1rem * 4);

        border-radius: calc(0.55rem * 4);
        box-shadow: inset 0 0 0 calc(0.02rem * 4) #fafafc;
      }

      .name {
        font-size: calc(0.24rem * 4);
        line-height: 1;
        // width: 2rem;

        @include sp {
          position: relative;
          bottom: 1.4rem;
          grid-area: 1/1;
          align-self: center;
          justify-self: center;
          font-size: calc(0.28rem * 3);
          // background-color: red;
          padding-left: 2rem;
          padding-right: 5rem;
        }
      }

      a {
        display: block;

        @include sp {
          grid-area: 1/1;
        }
      }

      img {
        @include sp {
          display: none;
        }
      }
    }

    .tel {
      a {
        width: calc(6.42rem * 4);
        margin: calc(0.3rem * 4) 0 0;

        @include sp {
          width: auto;
          margin: 0;
          position: relative;

          &::after {
            content: "";
            display: block;
            width: calc(0.45rem * 4);
            height: calc(0.45rem * 4);
            position: absolute;
            // top: calc(50% - calc(0.225rem * 4));
            top: -1.4rem;
            right: calc(0.47rem * 4);
            background-image: url(../assets/img/arw.svg),
              linear-gradient(90deg, #a3c436, #75888a);
            background-position: 50% 50%, 0 0;
            background-size: calc(0.09rem * 4) auto, cover;
            background-repeat: no-repeat;
            border-radius: 50%;
          }
        }
      }
    }

    .mail {
      border-left: calc(0.02rem * 4) solid #9f9fa0;
      padding-left: calc(1.1rem * 4);

      @include sp {
        border-left: none;
        padding-left: 0;
      }

      a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: calc(0.35rem * 4) 0 0;

        @include sp {
          display: block;
          margin: 0;
          position: relative;
        }

        img {
          width: calc(4.86rem * 4);
        }

        &::after {
          content: "";
          display: block;
          width: calc(0.5rem * 4);
          height: calc(0.5rem * 4);
          background-image: url(../assets/img/arw.svg),
            linear-gradient(90deg, #a3c436, #75888a);
          background-position: 50% 50%, 0 0;
          background-size: calc(0.09rem * 4) auto, cover;
          background-repeat: no-repeat;
          border-radius: 50%;
          position: relative;
          right: -1rem;

          @include sp {
            width: calc(0.45rem * 4);
            height: calc(0.45rem * 4);
            position: absolute;
            top: -1.4rem;
            right: calc(0.47rem * 4);
          }
        }
      }
    }
  }

  // ==========================================================================

  .corporate {
    padding: calc(1rem * 4) 0 calc(1.6rem * 4);

    @include sp {
      padding: calc(1.2rem * 4) 0;
      text-align: center;
    }

    .wrap-content {
      display: grid;
      grid-template-rows: repeat(4, absolute);
      grid-template-columns: repeat(2, 50%);
      width: 100%;
      max-width: 921px;
      margin: auto;
      padding: 2rem 3rem;

      @include sp {
        display: block;
      }
    }

    .logo {
      grid-row: 1/4;
      grid-column: 2/3;
      justify-self: flex-end;
      width: calc(2.61rem * 4);
      height: calc(0.68rem * 4);
      margin: calc(0.74rem * 4) 0 0;

      @include sp {
        width: calc(3.39rem * 4);
        height: calc(calc(3.39rem * 4) / calc(261 * 68));
        margin: 0 auto;
      }

      img {
        width: 100%;
        @include sp {
          position: relative;
          bottom: 2.5rem;
        }
      }
    }

    .address {
      @extend %textCrop;
      grid-row: 1/2;
      grid-column: 1/2;
      font-size: calc(0.18rem * 4);
      font-weight: 400;
      line-height: (calc(26 / 18));

      @include sp {
        padding: calc(0.46rem * 4) 0 0;
        font-size: calc(0.26rem * 4);
        line-height: (calc(41 / 26));
      }
    }

    .trademark {
      @extend %textCrop;
      grid-row: 2/3;
      grid-column: 1/2;
      margin: calc(0.12rem * 4) 0 0;
      font-size: calc(0.14rem * 4);
      font-weight: 400;
      line-height: (calc(28 / 20));

      @include sp {
        margin: 0;
        padding: calc(0.32rem * 4) 0 0;
        font-size: calc(0.2rem * 4);
        line-height: (calc(28 / 20));
      }
    }

    .sns {
      grid-row: 3/4;
      grid-column: 1/2;
      display: flex;
      align-items: center;
      gap: calc(0.12rem * 4);
      margin: calc(0.28rem * 4) 0 0;
      font-size: 1px;
      line-height: 1;

      @include sp {
        justify-content: center;
        gap: calc(0.2rem * 4);
        margin: calc(0.7rem * 4) 0 0;
      }

      a {
        display: block;
      }

      .x {
        width: calc(0.27rem * 4);

        @include sp {
          width: calc(0.43rem * 4);
        }
      }

      .facebook {
        display: flex;
        align-items: flex-end;
        box-sizing: border-box;
        width: calc(0.3rem * 4);
        height: calc(0.3rem * 4);
        padding: 0 calc(0.08rem * 4);
        background: #fafafc;
        border-radius: 50%;

        @include sp {
          width: calc(0.48rem * 4);
          height: calc(0.48rem * 4);
          padding: 0 calc(0.13rem * 4);
        }
      }

      .instagram {
        width: calc(0.27rem * 4);

        @include sp {
          width: calc(0.43rem * 4);
        }
      }
    }

    .privacy,
    .copyright {
      grid-row: 4/5;
      margin: calc(0.5rem * 4) 0 0;
      font-size: calc(0.16rem * 4);
      font-weight: 400;
      line-height: 1;

      @include sp {
        font-size: calc(0.2rem * 4);
      }
    }

    .privacy {
      grid-column: 1/2;
      display: flex;
      gap: 24px;

      .law-button {
        text-decoration: underline;

        &:hover {
          cursor: pointer;
        }
      }

      @include sp {
        margin: calc(0.5rem * 4) 0 0;
      }

      a {
        text-decoration: underline;
        text-underline-offset: calc(0.08rem * 4);
      }
    }

    .copyright {
      grid-column: 2/3;
      justify-self: flex-end;

      @include sp {
        margin: calc(1.2rem * 4) 0 0;
      }
    }
  }
}

// print
// #############################################################################################

@media print {
  .dashboard-page {
    zoom: 0.5;

    .gHeader {
      position: absolute;
    }
  }
}

.popup-law {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  width: 100vw;
  height: 100dvh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .popup-body {
    font-size: 16px;
    color: black;
    padding: 16px;
    background-color: white;
    width: 60%;
    height: 400px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 16px;

  }
  
  .popup-title {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  .close-popup-law {
    &:hover {
      cursor: pointer;
    }
  }

  .popup-body-message {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    padding: 12px;
    background-color: #95c41c4d;
    width: 100%;
    height: calc(100% - 23px);
    border-radius: 12px;
    font-size: 14px;
    font-weight: 400;
    overflow-y: scroll;
    

    .popup-margin {
      text-align: left;
      .popup-list-point {
        display: flex;
        align-items: center;
      }
      .list-point-desc {
        margin-left: 14px;
      }
    }

  }
}
</style>
